import React, { useState, useEffect } from 'react';
import { useAppContext } from '../context/AppContext';
import * as FiIcons from 'react-icons/fi';
const { FiClock, FiX } = FiIcons;

export default function UrgencyBanner() {
  const { pixelsSold } = useAppContext();
  const [dismissed, setDismissed] = useState(false);
  const [secs, setSecs] = useState(0);

  useEffect(() => {
    const now = Math.floor(Date.now() / 1000);
    const cycleLen = 15 * 60;
    setSecs(cycleLen - (now % cycleLen));
    const t = setInterval(() => setSecs(s => s <= 1 ? cycleLen : s - 1), 1000);
    return () => clearInterval(t);
  }, []);

  if (dismissed) return null;

  const mm = String(Math.floor(secs / 60)).padStart(2, '0');
  const ss = String(secs % 60).padStart(2, '0');
  const pctLeft = (((1000000 - pixelsSold) / 1000000) * 100).toFixed(1);

  return (
    <div className="fixed top-[88px] left-1/2 -translate-x-1/2 z-30 pointer-events-auto" style={{ maxWidth: '520px', width: '90vw' }}>
      <div className="flex items-center gap-3 px-4 py-2.5 rounded-xl"
        style={{ background: 'rgba(255,60,0,0.12)', border: '1px solid rgba(255,100,0,0.4)', backdropFilter: 'blur(12px)' }}>
        <FiClock className="text-orange-400 shrink-0 animate-blink" />
        <div className="flex-1 text-center">
          <span className="text-orange-300 font-black" style={{ fontSize: '14px' }}>Price lock expires in </span>
          <span className="font-black text-white font-mono" style={{ fontSize: '14px' }}>{mm}:{ss}</span>
          <span className="text-orange-300 font-black" style={{ fontSize: '14px' }}> — only </span>
          <span className="font-black text-white" style={{ fontSize: '14px' }}>{pctLeft}%</span>
          <span className="text-orange-300 font-black" style={{ fontSize: '14px' }}> of pixels remain!</span>
        </div>
        <button onClick={() => setDismissed(true)} className="text-gray-500 hover:text-gray-300 transition-colors shrink-0">
          <FiX className="text-xs" />
        </button>
      </div>
    </div>
  );
}